// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f651ce55","453":"c72f2af8","455":"de467f53"}[chunkId] + ".chunk.js";
};